import React, { ReactElement } from 'react';

import { InCorporationWithCoop } from 'App/themes/FooterCooperation/Cooperation/InCorporationWithCoop';
import { InCorporationWithAkademikerne } from './Cooperation/InCorperationWithAkademikerne';
import { InCorporationWithDanskeBank } from './Cooperation/InCorperationWithDanskeBank';

interface FooterCooperationProps {
  brand: string;
}

export const FooterCooperation = ({
  brand,
}: FooterCooperationProps): ReactElement | null => {
  switch (brand) {
    case 'akademikerne':
      return <InCorporationWithAkademikerne />;
    case 'danskeBank':
      return <InCorporationWithDanskeBank />;
    case 'coop':
      return <InCorporationWithCoop />;
    default:
      return null;
  }
};
